import type {AddComponentTypeOptions, ComponentDefinition} from 'grapesjs';
import {FORM_WRAPPER_STYLES} from '@FormMakerReact/components/component-styles';
import {POSTERMYWALL_SIGNUP_FORM_TYPE, buildDefaultSignupFormChildren} from '@FormMakerReact/components/postermywall-signup-form/postermywall-signup-form';
import {POSTERMYWALL_CONFIRMATION_FORM_TYPE, buildDefaultConfirmationFormChildren} from '@FormMakerReact/components/postermywall-confirmation-form/postermywall-confirmation-form';
import {POSTERMYWALL_ERROR_BOX_TYPE, buildDefaultErrorBoxChildren} from '@FormMakerReact/components/postermywall-error-box/postermywall-error-box';

export const POSTERMYWALL_FORMS_WRAPPER_TYPE = 'postermywall-forms-wrapper';
const DATA_ATTR = 'data-is-pmw-form-wrapper';

export function buildDefaultFormsWrapperLayout(): ComponentDefinition {
  return {
    type: POSTERMYWALL_FORMS_WRAPPER_TYPE,
    components: [
      {type: POSTERMYWALL_SIGNUP_FORM_TYPE, components: buildDefaultSignupFormChildren()},
      {type: POSTERMYWALL_CONFIRMATION_FORM_TYPE, components: buildDefaultConfirmationFormChildren()},
      {type: POSTERMYWALL_ERROR_BOX_TYPE, components: buildDefaultErrorBoxChildren()},
    ],
  };
}

export const POSTERMYWALL_FORMS_WRAPPER: AddComponentTypeOptions = {
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    return el.tagName === 'DIV' && el.getAttribute(DATA_ATTR) !== null ? {type: POSTERMYWALL_FORMS_WRAPPER_TYPE} : undefined;
  },
  model: {
    defaults: {
      tagName: 'div',
      toolbar: [],
      copyable: false,
      draggable: false,
      droppable: false,
      hoverable: false,
      selectable: false,
      highlightable: false,
      badgable: false,
      style: FORM_WRAPPER_STYLES,
      attributes: {
        [DATA_ATTR]: '1',
        id: POSTERMYWALL_FORMS_WRAPPER_TYPE,
      },
    },
  },
};
